import { useState, useEffect, useCallback } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from 'formik';
import { toast } from "react-toastify";
import $ from 'jquery';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import { format } from 'date-fns';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as leadActions from "../../actions/leadActions";
import * as masterAction from "../../actions/masterAction";
import AccessDenied from '../common/AccessDenied';
import * as incidentReporteActions from "../../actions/incidentReporteActions";
import CoApplicant from './CoApplicant';
import Guarantor from './Guarantor';
import * as groupsUsersActions from "../../actions/groupsUsersActions";


// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const VivritiApplicationDetails = (props) => { 
    const { id, actionName } = useParams();
    const { urlLoanApplicationID } = useParams();
    const location = useLocation();
    const { actions, leadsData, leadInfo, usersData, basicLeadInfo, masterProfileData, leadChecklistData, interactionTypeData, getUserModuleData, incidentReporteData, leadGstByLeadData, leadItrByLeadData, leadBankStatementByLeadData } = props;
     const [open, setOpen] = useState(false);
     
    const [showLeadDetails, setShowLeadDetails] = useState(false);
    const [leadData, setLeadData] = useState([]);
    const [leadId, setLeadId] = useState('');
    const [loanApplicationID, setLoanApplicationID] = useState('');
 
    const [vivritiApplicationID, setVivritiApplicationID] = useState('');
    const [vivritiAgreementSignedID, setVivritiAgreementSignedID] = useState('');
    const [vivritipostDisbursementID, setVivritipostDisbursementID] = useState('');
    const [allUsers, setAllUsers] = useState([]);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const navigate = useNavigate();
    const [customerCreatedStatus, setCustomerCreatedStatus] = useState(false);
    const [customerID, setCustomerID] = useState('');

    const [allCloudCustomerCreatedStatus, setAllCloudCustomerCreatedStatus] = useState(false);
    const [vivritiLoanID, setVivritiLoanID] = useState('');
    const [vivritiLoanStatus, setVivritiLoanStatus] = useState('');
    const [vivritiUpdateLoanStatus, setVivritiUpdateLoanStatus] = useState('');

    const [vivritiSavePostSanctionStatus, setVivritiSavePostSanctionStatus] = useState('');
    const [vivritiUpdatePostSanctionStatus, setVivritiUpdatePostSanctionStatus] = useState('');
     
     const [allCloudLeadID, setAllCloudLeadID] = useState('');
    const [allCloudLocalLeadID, setAllCloudLocalLeadID] = useState('');
    const [allCloudLoanLeadID, setAllCloudLoanLeadID] = useState('');
 
    const [allMasterProfiles, setAllMasterProfiles] = useState([]);
    const [pageHeading, setPageHeading] = useState('Vivriti Information');

    const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
    const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);
    const [permissions, setPermissions] = useState([]);

    const [panDetailsInfoGender, setPanDetailsInfoGender] = useState('');
    const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState('');
    const [leadPanDetails, setLeadPanDetails] = useState('');

    const [allGroupData, setAllGroupData] = useState([]);
    const [allCloudLoanSegments, setAllCloudLoanSegments] = useState([]);

    const [userRoleType, setUserRoleType] = useState('User');
    const [loggeInUserID, setLoggeInUserID] = useState('');
    const [isCrifUser, setIsCrifUser] = useState(true);

    const [allStates, setAllStates] = useState([]);
    const [allAddressTypes, setAllAddressTypes] = useState([]);
    const [showNote, setShowNote] = useState('');
    const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState('');

    const [selectedAssignedGroup, setSelectedAssignedGroup] = useState('');
    const [assignedUser, setAssignedUser] = useState("");

    const [isSentToCredit, setIsSentToCredit] = useState(true);

    const [allLeadActivity, setAllLeadActivity] = useState([]);


    const [scoreCard, setScoreCard] = useState("");
    const [vivritiLoanInfo, setVivritiLoanInfo] = useState([]);
    const [selectedSchemes, setSelectedSchemes] = useState("");
    const [allCloudSchemes, setAllCloudSchemes] = useState([]);
    const [allCloudLoanCategories, setAllCloudLoanCategories] = useState([]);
    const [allCloudLeadSources, setAllCloudLeadSources] = useState([]);
    const [allCloudCustomerLeadInfo, setAllCloudCustomerLeadInfo] = useState([]);
    const [customerLeadCreatedStatus, setCustomerLeadCreatedStatus] = useState(false);

    const [allCloudCustomerLoanInfo, setAllCloudCustomerLoanInfo] = useState([]);
    const [customerLoanCreatedStatus, setCustomerLoanCreatedStatus] = useState(false);

    const [allCloudOrganizationTypes, setAllCloudOrganizationTypes] = useState([]);
    const [allCloudProductTypes, setAllCloudProductTypes] = useState([]);
    const [allCloudLpcTypes, setAllCloudLpcTypes] = useState([]);
    const [allCloudEmploymentTypes, setAllCloudEmploymentTypes] = useState([]);
    const [companyDetailsStatus, setCompanyDetailsStatus] = useState(false);

    const [loanTypeIdArr, setLoanTypeIdArr] = useState([]);

    const [allDealerArr, setAllDealerArr] = useState([]);
    const [allSourcesNameArr, setAllSourcesNameArr] = useState([]);

    const [dealerArr, setDealerArr] = useState([]);
    const [sourcesNameArr, setSourcesNameArr] = useState([]);
    const [companyRoleArr, setCompanyRoleArr] = useState([]);
    const [purposeOfLoanArr, setPurposeOfLoanArr] = useState([]);
    const [vehiclesTypeArr, setVehiclesTypeArr] = useState([]);

    const [allVehicleMakeArr, setAllVehicleMakeArr] = useState([]);
    const [vehicleMakeArr, setVehicleMakeArr] = useState([]);
    const [centresArr, setCentresArr] = useState([]);
    const [centresFilteredArr, setCentresFilteredArr] = useState([]);

    const [allVehicleClassArr, setAllVehicleClassArr] = useState([]);
    const [vehicleClassArr, setVehicleClassArr] = useState([]);

    const [allVehicleClassVariantArr, setAllVehicleClassVariantArr] = useState([]);
    const [vehicleClassVariantArr, setVehicleClassVariantArr] = useState([]);
    const [formCAMValues, setFormCAMValues] = useState({});
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);
    const [isPurposeOfLoanDropdownDisabled, setIsPurposeOfLoanDropdownDisabled] = useState(false);
    const [isLoanTypeDropdownDisabled, setIsLoanTypeDropdownDisabled] = useState(false);

    const [isLoanSegmentDropdownDisabled, setIsLoanSegmentDropdownDisabled] = useState(false);

    const [currentDate, setCurrentDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
        });

    const [isLoanAmountDisabled, setIsLoanAmountDisabled] = useState(false); 
    const [isLoanTenureDisabled, setIsLoanTenureDisabled] = useState(false); 
    const [isLoanCategoryDisabled, setIsLoanCategoryDisabled] = useState(false);
    const [isProductTypeDisabled, setIsProductTypeDisabled] = useState(false);  
     const [isEmployerNameDisabled, setIsEmployerNameDisabled] = useState(false); 
     const [isAssetValueDisabled, setIsAssetValueDisabled] = useState(false);
     const [isSanctionAmountDisabled, setIsSanctionAmountDisabled] = useState(false); 
     const [formsDataRows, setFormsDataRows] = useState([]);
     const [formsUpdateLoanDataRows, setFormsUpdateLoanDataRows] = useState([]);
     const [formsPostDisbursementDocumentDataRows, setFormsPostDisbursementDocumentDataRows] = useState([]);
     const [formsUpdatePostDisbursementDocumentDataRows, setFormsUpdatePostDisbursementDocumentDataRows] = useState([]);
     const [vivritiCallbackValidations, setVivritiCallbackValidations] = useState([]);
     const [vivritiCallbackValidationsUL, setVivritiCallbackValidationsUL] = useState([]);
     const [vivritiCallbackValidationsSPS, setVivritiCallbackValidationsSPS] = useState([]);
     const [vivritiCallbackValidationsUPS, setVivritiCallbackValidationsUPS] = useState([]);
     const [gurantor1RelationshipWithApplicantMaster, setGurantor1RelationshipWithApplicantMaster] = useState([]);
     
     const [coApplicant1RelationshipWithApplicantMaster, setCoApplicant1RelationshipWithApplicantMaster] = useState([]);
     const [formValues, setFormValues] = useState({
        customerType: 'Individual',
        credit_score: '',
        remarks: '',
        caste: '',
        phone_number: '',
        contactreferencedto_name: '',
        contactreferencedto_contactnumber: '',
        contactreferencedto_town: '',
        contactreferencedto_address: '',
        contactreferencedto_area: '',
        contactreferencedto_postcode: '',
        company_name:'',
        customer_state:'',
        name_to_be_display:''
    });
 
    const [formLeadValues, setFormLeadValues] = useState({
        CompanyRoleId:'198',
        LoanSegmentId:'24',
        PurposeofLoan:'9',
        ProductTypeId:'VehicleLoan',
        loan_category:'General',
        lead_source: '',
        DealerId:'',
        lead_source_detail_id:'206',
        scheme_id:'20',
        mfgYear:'',
        vehicleTypeId:'20',
        vehicleClassId:'12',
        vehicleMakeId:'229',
        vehicleClassVariantId:'2',
        EmployerName:'',
        AnnualSalary:'100000',
        JoiningDate: currentDate,
        Designation:'NA',
        OrganizationType:'NA',
        Sector:'NA',
        AddressLine1:'NA',
        Area:'NA',
        Town:'NA',
        Postcode:'',
        OrganizationName:'NA',
        AnnualProfit:'100000',
        IncorporationDate:currentDate,
        IncorporationOrganizationType:'',
        AnnualIncome:'100000',
        IncorporationAddressLine1:'NA',
        IncorporationArea:'NA',
        IncorporationTown:'NA',
        IncorporationPostcode:'NA',
        IOTCompanyName:'NA',
        BatteryCompanyName:'NA',
        LoanAmount:'',
        LoanTenure:'',
        CentreName:'',
        DownPayment:'',
        LoanState:'0',
        LoanTypeId:'0',
        SubLoanTypeId:'0',
        ComfortableEMI:'1',
        AddressId:'0'
    });
   
    const [formLoanValues, setFormLoanValues] = useState({
        CompanyRoleId:'',
        LoanStateForPL: 'Unsecured',
        YearlyInterest: '',
        SanctionAmount: '',
        EMIStartDate: '',
        InstallmentTypeId: 'Monthly',
        ModeOfRePaymentId: 'eNACH',
        StartDate: '',
        LPC: '0',
        LPCType: '',
        EmploymentType: '',
        AssetValue: '0',
        UpFrontFee: '0', 
    });

    const filterRelationalDropdowns = (searchVal, action) =>{

        if(action === 'lead_source'){
            const sourceInfo = allCloudLeadSources.filter((item) => item.source_name === searchVal);
            let sourceId = sourceInfo?.[0]?.source_id;
            if(sourceInfo?.[0]?.source_id === null) {
                sourceId = '';
            } 

            setDealerArr([]); 
            setSourcesNameArr([]);  
            if(sourceId !==''){ 
                const allDealerData = allDealerArr.filter((item) => item.allcloud_parent_id === sourceId);
                const allSourcesNameData = allSourcesNameArr.filter((item) => item.allcloud_parent_id === sourceId);

                setDealerArr(allDealerData); 
                setSourcesNameArr(allSourcesNameData); 
            }
        }

 
        if(action === 'CompanyRoleId'){
             setCentresFilteredArr([]); 
             
            if(searchVal !==''){ 
                 const filteredData = centresArr.filter((item) => item.branch_id === searchVal); 
                 setCentresFilteredArr(filteredData);  
            }
        }

        if(action === 'vehicleTypeId'){
             setVehicleMakeArr([]); 
             setVehicleClassArr([]);  
             setVehicleClassVariantArr([]);    
            if(searchVal !==''){ 
                 const filteredData = allVehicleMakeArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleMakeArr(filteredData);  
            }
        }

        if(action === 'vehicleMakeId'){
             setVehicleClassArr([]);  
            if(searchVal !==''){ 
                 const filteredData = allVehicleClassArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleClassArr(filteredData);  
            }
        }

        if(action === 'vehicleClassId'){
             setVehicleClassVariantArr([]);  
            if(searchVal !==''){ 
                 const filteredData = allVehicleClassVariantArr.filter((item) => item.allcloud_parent_id === searchVal); 
                 setVehicleClassVariantArr(filteredData); 
            }
        } 
               
        
    };

    const handleInputSetFormChange = (type, value,field) => {
        setFormsDataRows((prev) => {
          const existingIndex = prev.findIndex((entry) =>  entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { type, value,field }];
        });
      };

       const handleInputSetFormPostDisbursementDocumentChange = (type, value,field) => {
        setFormsPostDisbursementDocumentDataRows((prev) => {
          const existingIndex = prev.findIndex((entry) =>  entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { type, value,field }];
        });
      };

      const handleInputSetFormUpdatePostDisbursementDocumentChange = (type, value,field) => {
        setFormsUpdatePostDisbursementDocumentDataRows((prev) => {
          const existingIndex = prev.findIndex((entry) =>  entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { type, value,field }];
        });
      };


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const leadPermissions = permissionsData.find(permission => permission.module_name === 'Leads');
                const hasAddPermissions = leadPermissions?.add_permission;
                const hasEditPermissions = leadPermissions?.edit_permission;

                setAddModulePermissionStatus(hasAddPermissions);
                setEditModulePermissionStatus(hasEditPermissions);
                setUserHasPermission(id !== undefined ? hasEditPermissions : hasAddPermissions);

                if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
                    setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);

                    setIsCrifUser(result.data.user_info[0].is_crif_user);
                }

            }
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });

        setAssignedUser("");
        setSelectedAssignedGroup("");

    }, [setPermissions, setUserHasPermission, setAssignedUser, setSelectedAssignedGroup]);

    useEffect(() => {
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData, false);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

     
     const autoUpdateField = (fieldName, value, formName) => {

        if(formName === 'lead'){
            setFormLeadValues((formLeadValues) => ({
            ...formLeadValues,  
            [fieldName]: value,  
            }));
         }else if(formName === 'loan'){
            setFormLoanValues((formLoanValues) => ({
            ...formLoanValues,  
            [fieldName]: value,  
            }));    
        }else{
             setFormValues((formValues) => ({
            ...formValues,  
            [fieldName]: value,  
            }));
        }
    };  

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.masterProfileData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.lead_profile_name.localeCompare(b.lead_profile_name)
                );
                setAllMasterProfiles(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

        setAllStates([]);
        setAllAddressTypes([]);
        const objStates = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestDataStates = encryptData(objStates);
        const responseStates = actions.masterStatesData(requestDataStates, false);
        responseStates.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                setAllStates(resultArr);

                const resultsAddressTypes = result.data.all_address_types.data;
                const resultAddressTypesArr = Object.keys(resultsAddressTypes).map((key) => resultsAddressTypes[key]);
                setAllAddressTypes(resultAddressTypesArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

        setLoanTypeIdArr([]); 
        setDealerArr([]); 
        setSourcesNameArr([]);
        setCompanyRoleArr([]);
        setPurposeOfLoanArr([]); 
        setVehiclesTypeArr([]); 
        const decodedId = atob(id);      
        const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'send_to_allcloud','lead_id': decodedId};
        const requestDataMasters = encryptData(objMasters);
        const responseMasters = actions.masterAllData(requestDataMasters, false);
        responseMasters.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data;

                const camDetails = results?.cam_details; 
                const jsonData = JSON.parse(camDetails); 
                setFormCAMValues(jsonData); 

                // console.log("000000000000000000000 resultArr = ",results)
                const loanTypeIdArrData = results.LoanTypeIdArr?.data || [];
                // console.log("000000000000000000000 loanTypeIdArrData = ",results.LoanTypeIdArr?.data || [])
                setLoanTypeIdArr(loanTypeIdArrData); 


                const dealerArrData = results.DealerArr?.data || [];
                setDealerArr(dealerArrData);  
                setAllDealerArr(dealerArrData);

                const sourcesNameArrData = results.SourcesNameArr?.data || [];
                setSourcesNameArr(sourcesNameArrData);
                setAllSourcesNameArr(sourcesNameArrData);

                const companyRoleArrData = results.CompanyRoleArr?.data || [];
                setCompanyRoleArr(companyRoleArrData);

                const centresArrData = results.CentresArr?.data || [];
                setCentresArr(centresArrData);

                const purposeOfLoanArrData = results.PurposeOfLoanArr?.data || [];
                setPurposeOfLoanArr(purposeOfLoanArrData);

                const vehiclesTypeArrData = results.VehiclesTypeArr?.data || [];
                setVehiclesTypeArr(vehiclesTypeArrData); 

                const vehicleMakeArrData = results.VehicleMakeArr?.data || [];
                setAllVehicleMakeArr(vehicleMakeArrData);

                 const vehicleClassArrData = results.VehicleClassArr?.data || [];
                setAllVehicleClassArr(vehicleClassArrData);

                const vehicleClassVariantArrData = results.VehicleClassVariantArr?.data || [];
                setAllVehicleClassVariantArr(vehicleClassVariantArrData); 

                
                const gurantor1RelationshipWithApplicantMasterData = results?.gurantor1RelationshipWithApplicantMaster; 
                setGurantor1RelationshipWithApplicantMaster(gurantor1RelationshipWithApplicantMasterData);
                
                 const coApplicant1RelationshipWithApplicantMasterData = results?.coApplicant1RelationshipWithApplicantMaster; 
                setCoApplicant1RelationshipWithApplicantMaster(coApplicant1RelationshipWithApplicantMasterData);
               
                
               // setTimeout(() => {
                     // autoUpdateField("LoanAmount", 1,'lead');  
                        
                        autoUpdateField("LoanAmount", jsonData?.irr_finance_amount,'lead');
                        autoUpdateField("LoanTenure", jsonData?.cam_loan_tenor_in_months,'lead');
                        autoUpdateField("CentreName", jsonData?.cam_location,'lead');
                        autoUpdateField("loan_category", "General",'lead');
                        autoUpdateField("ProductTypeId", "VehicleLoan",'lead');
                        autoUpdateField("lead_source", jsonData?.cam_source,'lead');
                        autoUpdateField("PurposeofLoan", "9",'lead');
                        autoUpdateField("LoanState", "0",'lead');
                        autoUpdateField("LoanTypeId", "0",'lead');
                        autoUpdateField("SubLoanTypeId", "0",'lead');
                        autoUpdateField("ComfortableEMI", "1",'lead');
                        autoUpdateField("AddressId", "0",'lead');
                        autoUpdateField("LoanSegmentId", "24",'lead');
                        autoUpdateField("vehicleTypeId", "20",'lead');
                        autoUpdateField("EmployerName", jsonData?.cam_sales_manager,'lead');
                        autoUpdateField("OrganizationName", jsonData?.cam_customer_name,'lead');
                        autoUpdateField("IncorporationDate", jsonData?.cam_dob,'lead');
                        autoUpdateField("IncorporationOrganizationType", jsonData?.cam_constitution,'lead');

                        autoUpdateField("AnnualProfit", "100000",'lead');
                        autoUpdateField("IncorporationDate", currentDate,'lead');
                        autoUpdateField("AnnualSalary", 100000,'lead');
                        autoUpdateField("JoiningDate", currentDate,'lead');

                         autoUpdateField("CompanyRoleId", "198",'lead');
                        autoUpdateField("lead_source_detail_id", "206",'lead');
                        autoUpdateField("scheme_id", "20",'lead');
 
 
                        autoUpdateField("AssetValue", jsonData?.cam_asset_cost,'loan');
                        autoUpdateField("SanctionAmount", jsonData?.cam_finance_value,'loan');
 

                        if(jsonData?.irr_finance_amount?.toString().trim() !==''){
                            setIsLoanAmountDisabled(true); 
                        }

                        if(jsonData?.cam_loan_tenor_in_months?.toString().trim() !==''){
                            setIsLoanTenureDisabled(true); 
                        }

                       // if(initialFormValues.loan_category !==''){
                             setIsLoanCategoryDisabled(true);
                       // }
                       // if(initialFormValues.ProductTypeId !==''){                       
                            setIsProductTypeDisabled(true); 
                       // } 
                        if(jsonData?.cam_sales_manager?.toString().trim() !==''){
                            setIsEmployerNameDisabled(true);
                        }

                        if(jsonData?.cam_asset_cost?.toString().trim() !==''){
                            setIsAssetValueDisabled(true);
                        }

                         if(jsonData?.cam_finance_value?.toString().trim() !==''){
                            setIsSanctionAmountDisabled(true);
                        }

                        

                        if(jsonData?.cam_source !== ''){                          
                            filterRelationalDropdowns(jsonData?.cam_source,'lead_source');                            
                             const isDropdownDisabledStatus = allCloudLeadSources.some(
                                (item) => item.source_name === jsonData?.cam_source
                                );
                            setIsDropdownDisabled(isDropdownDisabledStatus); 
                        }

                        const isPurposeOfLoandownDisabledStatus = purposeOfLoanArrData.some(
                                (item) => item.allcloud_id === "9"
                                ); 
                        setIsPurposeOfLoanDropdownDisabled(isPurposeOfLoandownDisabledStatus);

                        const isLoanTypeDropdownDisabledStatus = loanTypeIdArrData.some(
                                (item) => item.allcloud_id === "1"
                                ); 
                        setIsLoanTypeDropdownDisabled(isLoanTypeDropdownDisabledStatus); 
                        filterRelationalDropdowns("20",'vehicleTypeId');  
                         
              //  }, 500); 
 
            }
        }).catch((error) => {
           console.log("000000000000000000000 error  = ",error)
        });

    }, [setAllMasterProfiles, setAllStates,setLoanTypeIdArr, setDealerArr,setFormCAMValues]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudSchemesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.scheme_name.localeCompare(b.scheme_name)
            );
            setAllCloudSchemes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudSchemes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLoanCategoriesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.category_name.localeCompare(b.category_name)
            );
            setAllCloudLoanCategories(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLoanCategories]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLeadSourcesData(requestData, false);
        response.then((result) => {
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.source_name.localeCompare(b.source_name)
            );
            setAllCloudLeadSources(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLeadSources]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudOrganizationTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudOrganizationTypes(sortedResultArr);

            autoUpdateField("OrganizationType", "NA",'lead');
            autoUpdateField("IncorporationOrganizationType", "NA",'lead');
            
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudOrganizationTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudProductTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudProductTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudProductTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLpcTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudLpcTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLpcTypes]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudEmploymentTypesData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.type_name.localeCompare(b.type_name)
            );
            setAllCloudEmploymentTypes(sortedResultArr);
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudEmploymentTypes]);



    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.groupData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  groupData list:", result);
            if (result.data.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.group_name.localeCompare(b.group_name)
                );
                setAllGroupData(sortedResultArr);
            }
        }).catch((error) => {
            console.error("Promise rejected -  lead list:", error);
        });

    }, [setAllGroupData]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.allCloudLoanSegmentsData(requestData, false);
        response.then((result) => {
          
           if (result.data.success === 1) {
            
            const results = result.data.data.data;
            const resultArr = Object.keys(results).map((key) => results[key]);
            const filteredResultArr = resultArr.filter((item) => item.status === "1");
            const sortedResultArr = filteredResultArr.sort((a, b) =>
                a.LoanTypeId.localeCompare(b.LoanTypeId)
            );
            console.log("sortedResultArr = ", sortedResultArr);
            setAllCloudLoanSegments(sortedResultArr);

            const isLoanSegmentDropdownDisabledStatus = sortedResultArr.some(
                    (item) => item.LoanSegmentId === "24"
                    ); 
            setIsLoanSegmentDropdownDisabled(isLoanSegmentDropdownDisabledStatus);
 
           
          }
        }).catch((error) => {
         });
    
    }, [setAllCloudLoanSegments]);




    const fetchLeads = useCallback(() => {
        setShowLeadDetails(false);

        setShowNoteNoteByCredit("");
        setShowNote("");

        // console.log("fetchLeads calling ", id, showLeadDetails);
        if (urlLoanApplicationID !== undefined ) {
            const loanApplicationIDVal = atob(urlLoanApplicationID);            
            setLoanApplicationID(loanApplicationIDVal); 
        }


        if (id !== undefined && !showLeadDetails) {
            const decodedId = atob(id);
            setLeadId(decodedId);  
            setVivritiCallbackValidations([]);
            setVivritiCallbackValidationsUL([]);
            setVivritiCallbackValidationsSPS([]);
            setVivritiCallbackValidationsUPS([]);
            setVivritiLoanStatus('');
            setVivritiUpdateLoanStatus('');

            setVivritiApplicationID('');
            setVivritiAgreementSignedID('');
            setVivritipostDisbursementID('');
            setVivritiSavePostSanctionStatus('');
            setVivritiUpdatePostSanctionStatus('');
 
            const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'lead_id': decodedId ,  'loan_application_id': loanApplicationID, 'api_calling_module': 'vivriti'};
            const requestData = encryptData(obj);
            const response = actions.leadInfo(requestData, false);
            response.then((result) => {
                // console.log("Promise resolved -  leadInfo:", result); 
                if (result.data.success === 1) {

                    const leadInfoData = result.data.data;

                    if ('data' in leadInfoData && leadInfoData.data.length > 0) {
                        setShowLeadDetails(true);
                        setLeadData(leadInfoData.data);
                        
 
                        setPageHeading(` Vivriti Information (${leadInfoData.data[0].name} - ${leadInfoData.data[0].mobile} )`);
                        if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0], 'VivritiLoanInfo')) {
                            setVivritiLoanInfo(leadInfoData.data[0].VivritiLoanInfo);
 
                            if (leadInfoData.data[0].VivritiLoanInfo.length > 0) { 
                                 const formsDataParsedData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0]?.formsData); 
                                setFormsDataRows(formsDataParsedData);

                                setVivritiApplicationID(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_applicationId);
                                setVivritiAgreementSignedID(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_agreementSignedId);

                                setVivritipostDisbursementID(leadInfoData.data[0].VivritiLoanInfo[0]?.postDisbursementId);

                                console.log("formsDataParsedData 2 = ", formsDataParsedData);
                                
                                if( leadInfoData.data[0].VivritiLoanInfo[0]?.formsData_pdd !== ''){
                                    const formsDataPDDParsedData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0]?.formsData_pdd); 
                                    setFormsPostDisbursementDocumentDataRows(formsDataPDDParsedData);
                                }

                                if( leadInfoData.data[0].VivritiLoanInfo[0]?.formsData_updd !== ''){
                                    const formsDataUPDDParsedData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0]?.formsData_updd); 
                                    setFormsUpdatePostDisbursementDocumentDataRows(formsDataUPDDParsedData);
                                }

                                setCustomerCreatedStatus(true);
                                setCustomerID(leadInfoData.data[0].VivritiLoanInfo[0].id);

                                if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].VivritiLoanInfo[0], 'api_response')) {
                                    if(leadInfoData.data[0].VivritiLoanInfo[0].api_response !==''){
                                         const allcloudApiData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0].api_response);

                                         if (leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_applicationId !=='') {
                                            setAllCloudCustomerCreatedStatus(true);
                                            setVivritiLoanID(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_applicationId );     
                                         } 
                                    } 
                                    
                                } 
                              

                                if(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_Status === 'Completed'){
                                    setVivritiLoanStatus("Approved");
                                }else{
                                    setVivritiLoanStatus(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_Status);
                                } 
                                setVivritiUpdateLoanStatus(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_Status_ul);

                                setVivritiSavePostSanctionStatus(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_Status_sps);

                                setVivritiUpdatePostSanctionStatus(leadInfoData.data[0].VivritiLoanInfo[0]?.vivriti_Status_ups);

                                 if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].VivritiLoanInfo[0], 'vivriti_callback_validations')) {
                                    if(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations !==''){
                                         const vivritiCallbackValidationsData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations);
                                            setVivritiCallbackValidations(vivritiCallbackValidationsData);
                                    }

                                 }

                                 if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].VivritiLoanInfo[0], 'vivriti_callback_validations_ul')) {
                                    if(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_ul !==''){
                                         const vivritiCallbackValidationsULData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_ul);
                                            setVivritiCallbackValidationsUL(vivritiCallbackValidationsULData);
                                    }
                                 }

                                 if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].VivritiLoanInfo[0], 'vivriti_callback_validations_sps')) {
                                    if(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_sps !==''){
                                         const vivritiCallbackValidationsSPSData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_sps);
                                            setVivritiCallbackValidationsSPS(vivritiCallbackValidationsSPSData);
                                    }
                                 }

                                 if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0].VivritiLoanInfo[0], 'vivriti_callback_validations_ups')) {
                                    if(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_ups !==''){
                                         const vivritiCallbackValidationsUPSData = JSON.parse(leadInfoData.data[0].VivritiLoanInfo[0].vivriti_callback_validations_ups);
                                            setVivritiCallbackValidationsUPS(vivritiCallbackValidationsUPSData);
                                    }
                                 }

                                 
                            }
                        } 

                    }
                }


            }).catch((error) => {
                // console.error("Promise rejected -  leadInfo :", error);
            });
        }
        
    }, [id, setValue, setShowLeadDetails, setPageHeading, setSelectedAssignedGroup, setAssignedUser, setAllLeadActivity,setVivritiLoanID,setFormsDataRows,setFormsPostDisbursementDocumentDataRows,setFormsUpdatePostDisbursementDocumentDataRows]);
 
    useEffect(() => { 
         setTimeout(() => {
                 fetchLeads(); 
         }, 1500); 
    }, [fetchLeads]);

    
    const handleSubmitLoanUpdationFrm = (data) => {

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsOtherDataRows': formsUpdateLoanDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'update_loan'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
                 console.log("Update loan api response : ", result); 

               // alert(result.data.success);
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };

    const handleSubmitSavePostSanctionFrm = (data) => {

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsOtherDataRows': formsUpdateLoanDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'save_post_sanction'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
                 console.log("Save post sanction api response : ", result); 

                // alert(result.data.success);
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };

    const handleSubmitUpdatePostSanctionFrm = (data) => {

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsOtherDataRows': formsUpdateLoanDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'update_post_sanction'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
                 console.log("Update post sanction api response : ", result); 

               // alert(result.data.success);
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };

    const handleSubmitPostDisbursementDocumentFrm = (data) => {
            console.log("formsOtherDataRows = ", formsPostDisbursementDocumentDataRows);

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsOtherDataRows': formsPostDisbursementDocumentDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'post_disbursemen_document'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
                 console.log("Post disbursemen document api response : ", result); 

               // alert(result.data.success);
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };


    const handleUpdatePostDisbursementDocumentFrm = (data) => {
            console.log("formsOtherDataRows = ", formsUpdatePostDisbursementDocumentDataRows);

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsOtherDataRows': formsUpdatePostDisbursementDocumentDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'update_post_disbursemen_document'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
 
               // alert(result.data.success);
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };
    const handleSubmitLoanCreationFrm = (data) => {
            console.log("formsDataRows = ", formsDataRows);

            let leadIdNumber = '';
            if (Object.prototype.hasOwnProperty.call(leadData[0], 'mobile')) {
                leadIdNumber = leadData[0].id;
            }
 
            const params = { 'formsDataRows': formsDataRows, 'lead_id': leadIdNumber,  'loan_application_id': loanApplicationID , 'api_action' : 'create_loan'}; 
            console.log("params : ", params); 
            const requestData = encryptData(params);
            const response = actions.callLeadVivritiApis(requestData);

            response.then((result) => {
                // console.log("Promise resolved - add/edit lead form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setTimeout(() => {
                        fetchLeads();
                      //  const encodedId = btoa(leadId);
                      //  navigate(`/dashboard/vivriti-application-details/${encodedId}`);

                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                // console.error("Promise rejected - add/edit lead form:", error);
                toast.error(error, {
                    position: "top-right",
                });
            });
         
    };
  
    const handleClose = () => {
        setOpen(false);
    };


    const openHideCompanyFields = (customerType) => { 
        setCompanyDetailsStatus(customerType !== 'Individual');
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormValues((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value };
    
 
            if(e.target.name === 'customerType'){
                // Ensure the latest value is passed
                openHideCompanyFields(updatedValues.customerType);
            }
    
            return updatedValues;
        });
    };

     
    /* const openHideCompanyFields = () => {
        setCompanyDetailsStatus(false);
        alert(formValues.customerType);
        if(formValues.customerType !== 'Individual'){
            setCompanyDetailsStatus(true);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormValues({
            ...formValues,
            [name]: value,
        });

        openHideCompanyFields();

    }; */

    

    const handleLeadChange = (e) => {
        const { name, value } = e.target;

        setFormLeadValues({
            ...formLeadValues,
            [name]: value,
        }); 

        setFormLeadValues((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value }; 

            if(e.target.name === 'lead_source'){
                  filterRelationalDropdowns(updatedValues.lead_source,'lead_source'); 
                  const isDropdownDisabledStatus = allCloudLeadSources.some(
                    (item) => item.source_name === updatedValues.lead_source
                    );
                 //  setIsDropdownDisabled(isDropdownDisabledStatus); 
            }

            if(e.target.name === 'CompanyRoleId'){
                  filterRelationalDropdowns(updatedValues.CompanyRoleId,'CompanyRoleId'); 
            }

            if(e.target.name === 'vehicleTypeId'){
                  filterRelationalDropdowns(updatedValues.vehicleTypeId,'vehicleTypeId'); 
            }

            if(e.target.name === 'vehicleMakeId'){
                  filterRelationalDropdowns(updatedValues.vehicleMakeId,'vehicleMakeId'); 
            }

             if(e.target.name === 'vehicleClassId'){
                  filterRelationalDropdowns(updatedValues.vehicleClassId,'vehicleClassId'); 
            }

            return updatedValues;
        });

        

       
    };

    const handleLoanChange = (e) => {
        const { name, value } = e.target;

        setFormLoanValues({
            ...formLoanValues,
            [name]: value,
        });

    };


    if (!userHasPermission) {
        // Redirect or render an access denied message
        return <AccessDenied />;
    }

    return (
        <>
            <Helmet>
                <title> Vivriti Information | Ckers </title>
            </Helmet>
            <Container>
                <div className='row align-items-center'>
                    <div className='col-md-6'>
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            {pageHeading}
                        </Typography>
                    </div>
                </div>

<div id='main-wrap' className='mb-5'>
<div className="tab-content show " id="pills-tabContent">
<div className="tab-pane fade show active" id="pills-lead-info" role="tabpanel" aria-labelledby="pills-lead-info-tab" tabIndex="0">

<div className="tab-content" id="pills-tabContent">
    <div className="tab-pane fade show active" id="pills-basic-info" role="tabpanel" aria-labelledby="pills-basic-info-tab" tabIndex="0">
        <div className="accordion first-level" id="accordionLI">
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button className={customerCreatedStatus ? "accordion-button bg-green" : "accordion-button "} type="button" data-bs-toggle="collapse" data-bs-target="#LI-1" aria-expanded="true" aria-controls="LI-1" role="tab" aria-selected={leadId === '' ? "true" : "false"} disabled={leadId === ''}>
                        Create Vivriti Loan
                    </button>
                </h2>
                <div id="LI-1" className="accordion-collapse collapse show "
                    data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">

                        <form onSubmit={handleSubmit(handleSubmitLoanCreationFrm)}>
                            <div className='row'>
                                <div className='col-md-12 bg-skyblue- '>
                                    <div className='row'>
                                        <div className="col-md-3 ">
                                            <div className="form-group">
                                                <label htmlFor="customerType">
                                                    <span>Customer Type <a style={{ color: "red" }}>*</a></span>
                                                     {(() => {  
                                                        const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'customerType');;
                                                        return (
                                                            <> 
                                                                  <select id="customerType" name="customerType" className="form-select"  {...register('customerType')}
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'customerType')}>
                                                                    <option value="Individual">Individual</option>
                                                                    <option value="Non-Individual">Non-Individual</option>
                                                                        <option value="Captive">Captive</option>
                                                                </select>
                                                            </>
                                                        );
                                                    })()} 
                                                </label>
                                            </div>
                                        </div> 

                                        <div className="col-md-3 ">
                                            <div className="form-group">
                                                <label htmlFor="employmentStatus">
                                                    <span>Employment Status <a style={{ color: "red" }}>*</a></span> 
                                                    {(() => {  
                                                        const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'customerType');;
                                                        return (
                                                            <>  
                                                                 <select id="employmentStatus" name="employmentStatus" className="form-select"  {...register('employmentStatus')}
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'employmentStatus')}>
                                                                    
                                                                    <option value="Salaried">Salaried</option>
                                                                    <option value="Premium Salaried">Premium Salaried</option>
                                                                    <option value="Self Employed">Self Employed</option>
                                                                    <option value="Self Employed Professional">Self Employed Professional</option>
                                                                    <option value="Student">Student</option>
                                                                    <option value="Unemployed">Unemployed</option>
                                                                    <option value="Others">Others</option>
                                                                    <option value="Self Employed Non Professional">Self Employed Non Professional</option>
                                                                    <option value="Income From Rent">Income From Rent</option>
                                                                    
                                                                </select>
                                                            </>
                                                        );
                                                    })()}
                                                </label>
                                            </div>
                                        </div>

    <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="currentDistrict">
                <span>Current District </span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'currentDistrict');;
                    return (
                        <>  
                            <input id="currentDistrict" name="currentDistrict" className="form-control"  {...register('currentDistrict')}
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'currentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div> 

     <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="currentCity">
                <span>Current City </span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'currentCity');;
                    return (
                        <>  
                            <input id="currentCity" name="currentCity" className="form-control"  {...register('currentCity')}
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'currentCity')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>  

    <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="permanentDistrict">
                <span>Permanent District </span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'permanentDistrict');;
                    return (
                        <>  
                            <input id="permanentDistrict" name="permanentDistrict" className="form-control"  {...register('permanentDistrict')}
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'permanentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div> 

    <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="permanentCity">
                <span>Permanent City </span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'permanentCity');;
                    return (
                        <>  
                            <input id="permanentCity" name="permanentCity" className="form-control"  {...register('permanentCity')}
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'permanentCity')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>

    <div className="col-md-3">
    <div className="form-group">
        <label htmlFor="permanentState">
            <span>Permanent State</span> 
                 {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'permanentState');;
                    return (
                        <>  
                                <select id="permanentState" name="permanentState" className="form-select"  {...register('permanentState')}
                                value={selectedArr?.[0]?.value}
                                onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'permanentState')}>
                                <option value=''>Select select</option>
                                {allStates.map((option) => (
                                    <option value={option.vivriti_id}>
                                        {option.state_name}
                                    </option>
                                ))}                                
                            </select>
                        </>
                    );
                })()}
        </label>
    </div>
</div> 

<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="noOfCoApplicants">
                <span>No Of CoApplicants</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'noOfCoApplicants');;
                    return (
                        <>  
                            <input id="noOfCoApplicants" name="noOfCoApplicants" className="form-control"  {...register('noOfCoApplicants')}
                            type="number"
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'noOfCoApplicants')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div> 

    <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="noOfGuarantors">
                <span>No Of Guarantors</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'noOfGuarantors');;
                    return (
                        <>  
                            <input id="noOfGuarantors" name="noOfGuarantors" className="form-control"  {...register('noOfGuarantors')}
                            type="number"
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'noOfGuarantors')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div> 



                                    </div> 

 <div className='row'> 
                <div className='row'><h4>Co-Applicant Details</h4></div>
                <hr/>

   <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantGender">
                <span>Co Applicant Gender</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantGender');;
                    return (
                        <>  
                            <input id="coApplicantGender" name="coApplicantGender" className="form-control"  {...register('coApplicantGender')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantGender')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantCurrentAddress">
                <span>Co Applicant Current Address</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantCurrentAddress');;
                    return (
                        <>  
                            <input id="coApplicantCurrentAddress" name="coApplicantCurrentAddress" className="form-control"  {...register('coApplicantCurrentAddress')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantCurrentAddress')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantCurrentDistrict">
                <span>Co Applicant Current District</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantCurrentDistrict');;
                    return (
                        <>  
                            <input id="coApplicantCurrentDistrict" name="coApplicantCurrentDistrict" className="form-control"  {...register('coApplicantCurrentDistrict')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantCurrentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantPermanentDistrict">
                <span>Co Applicant Permanent District</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantPermanentDistrict');;
                    return (
                        <>  
                            <input id="coApplicantPermanentDistrict" name="coApplicantPermanentDistrict" className="form-control"  {...register('coApplicantPermanentDistrict')}
                             
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantPermanentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantPermanentCity">
                <span>Co Applicant Permanent City</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantPermanentCity');;
                    return (
                        <>  
                            <input id="coApplicantPermanentCity" name="coApplicantPermanentCity" className="form-control"  {...register('coApplicantPermanentCity')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantPermanentCity')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantResidenceTypePermanentAddress">
                <span>Co Applicant Residence Type Permanent Address</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantResidenceTypePermanentAddress');;
                    return (
                        <>  
                            <input id="coApplicantResidenceTypePermanentAddress" name="coApplicantResidenceTypePermanentAddress" className="form-control"  {...register('coApplicantResidenceTypePermanentAddress')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantResidenceTypePermanentAddress')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantFatherName">
                <span>Co Applicant Father Name</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantFatherName');;
                    return (
                        <>  
                            <input id="coApplicantFatherName" name="coApplicantFatherName" className="form-control"  {...register('coApplicantFatherName')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantFatherName')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantRelationshipWithApplicant">
                <span>Co Applicant Relationship With Applicant</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantRelationshipWithApplicant');;
                    return (
                        <>  
                          { /*  <input id="coApplicantRelationshipWithApplicant" name="coApplicantRelationshipWithApplicant" className="form-control"  {...register('coApplicantRelationshipWithApplicant')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantRelationshipWithApplicant')} /> */ } 

                             <select id="coApplicantRelationshipWithApplicant" name="coApplicantRelationshipWithApplicant" className="form-select"  {...register('coApplicantRelationshipWithApplicant')}
                                value={selectedArr?.[0]?.value}
                                onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantRelationshipWithApplicant')}>
                                <option value=''>Select select</option>
                                {Object.entries(coApplicant1RelationshipWithApplicantMaster).map(([key, value]) => (
                                <option key={key} value={key}>
                                    {value}
                                </option>
                                ))}                              
                            </select>
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="coApplicantBureauScore">
                <span>Co Applicant Bureau Score</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'coApplicantBureauScore');;
                    return (
                        <>  
                            <input id="coApplicantBureauScore" name="coApplicantBureauScore" className="form-control"  {...register('coApplicantBureauScore')}
                            type="number"
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'coApplicantBureauScore')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>


</div> 

 <div className='row'> 
                <div className='row'><h4>Guarantor Details</h4></div>
                <hr/>

   <div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorGender">
                <span>Guarantor Gender</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorGender');;
                    return (
                        <>  
                            <input id="guarantorGender" name="guarantorGender" className="form-control"  {...register('guarantorGender')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorGender')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorCurrentDistrict">
                <span>Guarantor Current District</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorCurrentDistrict');;
                    return (
                        <>  
                            <input id="guarantorCurrentDistrict" name="guarantorCurrentDistrict" className="form-control"  {...register('guarantorCurrentDistrict')}                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorCurrentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorCurrentCity">
                <span>Guarantor Current City</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorCurrentCity');;
                    return (
                        <>  
                            <input id="guarantorCurrentCity" name="guarantorCurrentCity" className="form-control"  {...register('guarantorCurrentCity')}                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorCurrentCity')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorYearsOfStayInCurrentAddress">
                <span>Guarantor Years Of Stay In Current Address</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorYearsOfStayInCurrentAddress');;
                    return (
                        <>  
                            <input id="guarantorYearsOfStayInCurrentAddress" name="guarantorYearsOfStayInCurrentAddress" className="form-control"  {...register('guarantorYearsOfStayInCurrentAddress')}                             
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorYearsOfStayInCurrentAddress')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorPermanentDistrict">
                <span>Guarantor Permanent District</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorPermanentDistrict');;
                    return (
                        <>  
                            <input id="guarantorPermanentDistrict" name="guarantorPermanentDistrict" className="form-control"  {...register('guarantorPermanentDistrict')}                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorPermanentDistrict')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorResidenceTypePermanentAddress">
                <span>Guarantor Residence Type Permanent Address</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorResidenceTypePermanentAddress');;
                    return (
                        <>  
                            <input id="guarantorResidenceTypePermanentAddress" name="guarantorResidenceTypePermanentAddress" className="form-control"  {...register('guarantorResidenceTypePermanentAddress')}                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorResidenceTypePermanentAddress')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorRelationshipWithApplicant">
                <span>Guarantor Relationship With Applicant</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorRelationshipWithApplicant');;
                    return (
                        <>  
                         {/*   <input id="guarantorRelationshipWithApplicant" name="guarantorRelationshipWithApplicant" className="form-control"  {...register('guarantorRelationshipWithApplicant')}
                            
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorRelationshipWithApplicant')} /> */ }

                             <select id="guarantorRelationshipWithApplicant" name="guarantorRelationshipWithApplicant" className="form-select"  {...register('guarantorRelationshipWithApplicant')}
                                value={selectedArr?.[0]?.value}
                                onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorRelationshipWithApplicant')}>
                                <option value=''>Select select</option>
                                {Object.entries(gurantor1RelationshipWithApplicantMaster).map(([key, value]) => (
                                <option key={key} value={key}>
                                    {value}
                                </option>
                                ))}                              
                            </select>
                        </>
                    );
                })()}
            </label>
        </div>
    </div>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="guarantorBureauScore">
                <span>Guarantor Bureau Score</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'guarantorBureauScore');;
                    return (
                        <>  
                            <input id="guarantorBureauScore" name="guarantorBureauScore" className="form-control"  {...register('guarantorBureauScore')}
                            type="number"
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'guarantorBureauScore')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>

 </div>


 <div className="row">
    <hr/>
<div className="col-md-3 ">
        <div className="form-group">
            <label htmlFor="creditInsuranceNomineeName">
                <span>Credit Insurance Nominee Name</span> 
                {(() => {  
                    const selectedArr = formsDataRows.filter(item =>  item.type === 'loan_creation' && item.field === 'creditInsuranceNomineeName');;
                    return (
                        <>  
                            <input id="coApplicantBureauScore" name="creditInsuranceNomineeName" className="form-control"  {...register('creditInsuranceNomineeName')}
                            value={selectedArr?.[0]?.value}
                            onChange={(e) => handleInputSetFormChange("loan_creation", e.target.value,'creditInsuranceNomineeName')} />
                        </>
                    );
                })()}
            </label>
        </div>
    </div>


 </div>


                                </div>
                                <hr className="d-none"/>
                              {vivritiLoanStatus !== 'Approved' && ( 
                                <>  
                                        <div className='col-md-12 mt-2'>
                                    <div className='form-group mb-2 float-right'>
                                        <button className="btn btn-primary"> Create Loan</button>
                                    </div>
                                </div>
                              </>
                                )}   
                            {vivritiLoanID !== '' && (
                                <>
                                <div className='col-md-12 mt-2'>
                                    <div className='col-md-12 form-group mb-2 float-right text-success'>
                                        <b>Application ID #{vivritiLoanID}</b>
                                    </div> 

                                     <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                     {vivritiCallbackValidations.map((option) => (
                                            <div>
                                                {option}
                                            </div>
                                        ))}
                                        </div>  

                                        { vivritiAgreementSignedID !== '' && (
                                            <div className='col-md-12 form-group mb-2 float-right text-success'>The Agreement Signed ID has been generated.</div>
                                        )} 


                                        {vivritiLoanStatus !== '' && (
                                        <>
                                        <div className='col-md-12 form-group mb-2 float-right'>
                                            <b>Currect Status -  {vivritiLoanStatus}</b>
                                        </div>
                                        </>                                       
                                        )}     
                                </div>
                                </>
                                )}  
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button  className={customerLeadCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "} type="button" data-bs-toggle="collapse" data-bs-target="#LI-2" aria-expanded="true" aria-controls="LI-2" role="tab" aria-selected={vivritiLoanStatus !== 'Approved'  ? "true" : "false"} disabled={vivritiLoanStatus !== 'Approved'}>
                        Update Loan
                    </button> 
                </h2>
                <div id="LI-2" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                            <form onSubmit={handleSubmit(handleSubmitLoanUpdationFrm)}>
                                <div className='row'> 
                                     <div className='col-md-12 mt-2'>
                                        <div className='form-group mb-2 float-right'>
                                            <button className="btn btn-primary" disabled={vivritiAgreementSignedID !== ''}> Update Loan </button>
                                        </div>
                                    </div>

                                     {vivritiLoanID !== '' && (
                                    <>
                                    <div className='col-md-12 mt-2'>
                                        <div className='col-md-12 form-group mb-2 float-right text-success'>
                                            <b>Application ID #{vivritiLoanID}</b>
                                        </div>

                                        <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                         {Array.isArray(vivritiCallbackValidationsUL) ? (
                                            vivritiCallbackValidationsUL.map((option) => (
                                            <div>
                                                {option}
                                            </div> 
                                            ))
                                            ) : (
                                            <div>{vivritiCallbackValidationsUL}</div>
                                            )}
                                         </div> 

                                         { vivritiAgreementSignedID !== '' && (
                                            <div className='col-md-12 form-group mb-2 float-right text-success'>The Agreement Signed ID has been generated.</div>
                                        )} 

                                        {vivritiUpdateLoanStatus !== '' && (
                                        <>
                                        <div className='col-md-12 form-group mb-2 float-right'>
                                            <b>Currect Status -  {vivritiUpdateLoanStatus}</b>
                                        </div>
                                        </>                                       
                                        )}     
                                    </div>
                                    </>
                                    )} 
 
                                </div>    
                            </form>


                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button  className={customerLoanCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "}  type="button" data-bs-toggle="collapse" data-bs-target="#LI-3" aria-expanded="true" aria-controls="LI-3" role="tab" aria-selected={(vivritiUpdateLoanStatus !== 'Approved') ? "true" : "false"} disabled={vivritiUpdateLoanStatus !== 'Approved'}>
                        Save Post Sanction
                    </button>
                </h2>
                <div id="LI-3" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                         <form onSubmit={handleSubmit(handleSubmitSavePostSanctionFrm)}>
                                <div className='row'> 
                                     <div className='col-md-12 mt-2'>
                                        <div className='form-group mb-2 float-right'>
                                            <button className="btn btn-primary"> Save Post Sanction </button>
                                        </div>
                                    </div>

                                     {vivritiLoanID !== '' && (
                                    <>
                                    <div className='col-md-12 mt-2'>
                                        <div className='col-md-12 form-group mb-2 float-right text-success'>
                                            <b>Application ID #{vivritiLoanID}</b>
                                        </div>

                                        <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                         {Array.isArray(vivritiCallbackValidationsSPS) ? (
                                            vivritiCallbackValidationsSPS.map((option) => (
                                            <div>
                                                {option}
                                            </div> 
                                            ))
                                            ) : (
                                            <div>{vivritiCallbackValidationsSPS}</div>
                                            )}
                                         </div> 
                                         { vivritiAgreementSignedID !== '' && (
                                            <div className='col-md-12 form-group mb-2 float-right text-success'>The Agreement Signed ID has been generated.</div>
                                        )} 

                                         {vivritiSavePostSanctionStatus !== '' && (
                                        <>
                                        <div className='col-md-12 form-group mb-2 float-right'>
                                            <b>Currect Status -  {vivritiSavePostSanctionStatus}</b>
                                        </div>
                                        </>                                       
                                        )}          
                                    </div>
                                    </>
                                    )} 
 
                                </div>    
                            </form>
                    </div>
                </div>
            </div>

            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button  className={customerLoanCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "}  type="button" data-bs-toggle="collapse" data-bs-target="#LI-4" aria-expanded="true" aria-controls="LI-4" role="tab" aria-selected={vivritiUpdateLoanStatus !== 'Approved' ? "true" : "false"} disabled={ vivritiUpdateLoanStatus !== 'Approved'}>
                        Update Post Sanction 
                    </button>
                </h2>
                <div id="LI-4" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                         <form onSubmit={handleSubmit(handleSubmitUpdatePostSanctionFrm)}>
                                <div className='row'> 
                                     <div className='col-md-12 mt-2'>
                                        <div className='form-group mb-2 float-right'>
                                            <button className="btn btn-primary" disabled={ vivritiAgreementSignedID === ''}> Update Post Sanction </button>
                                        </div> 
                                    </div>
 
                                     {vivritiLoanID !== '' && (
                                    <>
                                    <div className='col-md-12 mt-2'>
                                        <div className='col-md-12 form-group mb-2 float-right text-success'>
                                            <b>Application ID #{vivritiLoanID}</b>
                                        </div>

                                        <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                         {Array.isArray(vivritiCallbackValidationsUPS) ? (
                                            vivritiCallbackValidationsUPS.map((option) => (
                                            <div>
                                                {option}
                                            </div> 
                                            ))
                                            ) : (
                                            <div>{vivritiCallbackValidationsUPS}</div>
                                            )}
                                            { vivritiAgreementSignedID === '' && (
                                                <div>The Agreement Signed ID has not been generated from Vivriti's side.</div>
                                            )}
                                         </div> 
                                           { vivritiAgreementSignedID !== '' && (
                                                <div className='col-md-12 form-group mb-2 float-right text-success'>The Agreement Signed ID has been generated.</div>
                                            )}
                                                       
                                          {vivritiUpdatePostSanctionStatus !== '' && (
                                            <>
                                            <div className='col-md-12 form-group mb-2 float-right'>
                                                <b>Currect Status -  {vivritiUpdatePostSanctionStatus}</b>
                                            </div>
                                            </>                                       
                                            )}    
                                    </div>
                                    </>
                                    )} 
 
                                </div>    
                            </form>
                    </div>
                </div>
            </div>


             <div className="accordion-item">
                <h2 className="accordion-header">
                    <button  className={customerLoanCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "}  type="button" data-bs-toggle="collapse" data-bs-target="#LI-5" aria-expanded="true" aria-controls="LI-5" role="tab" aria-selected={vivritiUpdateLoanStatus !== 'Approved' ? "true" : "false"} disabled={ vivritiUpdateLoanStatus !== 'Approved'}>
                       Post Disbursement Document
                    </button>
                </h2>
                <div id="LI-5" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                         <form onSubmit={handleSubmit(handleSubmitPostDisbursementDocumentFrm)}>
                                <div className='row'> 
                                     <div className='col-md-12 mt-2'>
                                        <div className='form-group mb-2 float-right'>
                                           <button
                                                className="btn btn-primary"
                                                disabled={vivritiAgreementSignedID === ''}
                                                title={
                                                    vivritiAgreementSignedID === ''
                                                    ? "The Agreement Signed ID has not been generated from Vivriti's side."
                                                    : ""
                                                }
                                                >
                                                Post Disbursement Document
                                                </button>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="UMRN">
                                                <span>UMRN</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'UMRN');;
                                                    return (
                                                        <>  
                                                            <input id="UMRN" name="UMRN" className="form-control"  {...register('UMRN')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'UMRN')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>


                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="vehicleRegNo">
                                                <span>Vehicle Reg No</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'vehicleRegNo');;
                                                    return (
                                                        <>  
                                                            <input id="vehicleRegNo" name="vehicleRegNo" className="form-control"  {...register('vehicleRegNo')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'vehicleRegNo')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="vehicleRegistrationDate">
                                                <span>Vehicle Registration Date</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'vehicleRegistrationDate');;
                                                    return (
                                                        <>  
                                                            <input id="vehicleRegistrationDate" name="vehicleRegistrationDate" className="form-control"  {...register('vehicleRegistrationDate')}
                                                            type="date"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'vehicleRegistrationDate')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="creditInsurancePolicyNumber">
                                                <span>Credit Insurance Policy Number</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'creditInsurancePolicyNumber');;
                                                    return (
                                                        <>  
                                                            <input id="creditInsurancePolicyNumber" name="creditInsurancePolicyNumber" className="form-control"  {...register('creditInsurancePolicyNumber')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'creditInsurancePolicyNumber')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsuranceName">
                                                <span>Asset Insurance Name</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'assetInsuranceName');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsuranceName" name="assetInsuranceName" className="form-control"  {...register('assetInsuranceName')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'assetInsuranceName')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsuranceAmount">
                                                <span>Asset Insurance Amount</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'assetInsuranceAmount');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsuranceAmount" name="assetInsuranceAmount" className="form-control"  {...register('assetInsuranceAmount')}
                                                            type="number"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'assetInsuranceAmount')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsurancePolicyNumber">
                                                <span>Asset Insurance Policy Number</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'assetInsurancePolicyNumber');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsurancePolicyNumber" name="assetInsurancePolicyNumber" className="form-control"  {...register('assetInsurancePolicyNumber')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'assetInsurancePolicyNumber')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsurerName">
                                                <span>Asset Insurer Name</span> 
                                                {(() => {  
                                                    const selectedArr = formsPostDisbursementDocumentDataRows.filter(item =>  item.type === 'post_disbursement_document' && item.field === 'assetInsurerName');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsurerName" name="assetInsurerName" className="form-control"  {...register('assetInsurerName')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormPostDisbursementDocumentChange("post_disbursement_document", e.target.value,'assetInsurerName')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>



                                     {vivritiLoanID !== '' && (
                                    <>
                                    <div className='col-md-12 mt-2'>
                                        <div className='col-md-12 form-group mb-2 float-right text-success'>
                                            <b>Application ID #{vivritiLoanID}</b>
                                        </div>

                                        <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                         {Array.isArray(vivritiCallbackValidationsUPS) ? (
                                            vivritiCallbackValidationsUPS.map((option) => (
                                            <div>
                                                {option}
                                            </div> 
                                            ))
                                            ) : (
                                            <div>{vivritiCallbackValidationsUPS}</div>
                                            )}
                                            { vivritiAgreementSignedID === '' && (
                                                <div>The Agreement Signed ID has not been generated from Vivriti's side.</div>
                                            )}
                                         </div>     
                                    </div>
                                    </>
                                    )} 
 
                                </div>    
                            </form>
                    </div>
                </div>
            </div>


             <div className="accordion-item">
                <h2 className="accordion-header">
                    <button  className={customerLoanCreatedStatus ? "accordion-button collapsed bg-green" : "accordion-button collapsed "}  type="button" data-bs-toggle="collapse" data-bs-target="#LI-6" aria-expanded="true" aria-controls="LI-6" role="tab" aria-selected={vivritiUpdateLoanStatus !== 'Approved' ? "true" : "false"} disabled={ vivritiUpdateLoanStatus !== 'Approved'}>
                       Update Post Disbursement Document
                    </button>
                </h2>
                <div id="LI-6" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                         <form onSubmit={handleSubmit(handleUpdatePostDisbursementDocumentFrm)}>
                                <div className='row'> 
                                     <div className='col-md-12 mt-2'>
                                        <div className='form-group mb-2 float-right'>
                                           <button
                                                className="btn btn-primary"
                                                disabled={vivritipostDisbursementID === ''}
                                                title={
                                                    vivritipostDisbursementID === ''
                                                    ? "The Post Disbursement ID has not been generated from Vivriti's side."
                                                    : ""
                                                }
                                                >
                                                Update Post Disbursement Document
                                                </button>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="UMRN_UPDD">
                                                <span>UMRN</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'UMRN_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="UMRN_UPDD" name="UMRN_UPDD" className="form-control"  {...register('UMRN_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'UMRN_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>


                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="vehicleRegNo_UPDD">
                                                <span>Vehicle Reg No</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'vehicleRegNo_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="vehicleRegNo" name="vehicleRegNo_UPDD" className="form-control"  {...register('vehicleRegNo_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'vehicleRegNo_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="vehicleRegistrationDate_UPDD">
                                                <span>Vehicle Registration Date</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'vehicleRegistrationDate_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="vehicleRegistrationDate_UPDD" name="vehicleRegistrationDate_UPDD" className="form-control"  {...register('vehicleRegistrationDate_UPDD')}
                                                            type="date"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'vehicleRegistrationDate_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="creditInsurancePolicyNumber_UPDD">
                                                <span>Credit Insurance Policy Number</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'creditInsurancePolicyNumber_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="creditInsurancePolicyNumber_UPDD" name="creditInsurancePolicyNumber_UPDD" className="form-control"  {...register('creditInsurancePolicyNumber_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'creditInsurancePolicyNumber_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsuranceName_UPDD">
                                                <span>Asset Insurance Name</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'assetInsuranceName_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsuranceName_UPDD" name="assetInsuranceName_UPDD" className="form-control"  {...register('assetInsuranceName_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'assetInsuranceName_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsuranceAmount_UPDD">
                                                <span>Asset Insurance Amount</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'assetInsuranceAmount_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsuranceAmount_UPDD" name="assetInsuranceAmount_UPDD" className="form-control"  {...register('assetInsuranceAmount_UPDD')}
                                                            type="number"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'assetInsuranceAmount_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsurancePolicyNumber_UPDD">
                                                <span>Asset Insurance Policy Number</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'assetInsurancePolicyNumber_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsurancePolicyNumber_UPDD" name="assetInsurancePolicyNumber_UPDD" className="form-control"  {...register('assetInsurancePolicyNumber_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'assetInsurancePolicyNumber_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <div className="form-group">
                                            <label htmlFor="assetInsurerName_UPDD">
                                                <span>Asset Insurer Name</span> 
                                                {(() => {  
                                                    const selectedArr = formsUpdatePostDisbursementDocumentDataRows.filter(item =>  item.type === 'update_post_disbursement_document' && item.field === 'assetInsurerName_UPDD');;
                                                    return (
                                                        <>  
                                                            <input id="assetInsurerName_UPDD" name="assetInsurerName_UPDD" className="form-control"  {...register('assetInsurerName_UPDD')}
                                                            type="text"
                                                            value={selectedArr?.[0]?.value}
                                                            onChange={(e) => handleInputSetFormUpdatePostDisbursementDocumentChange("update_post_disbursement_document", e.target.value,'assetInsurerName_UPDD')} />
                                                        </>
                                                    );
                                                })()}
                                            </label>
                                        </div>
                                    </div>



                                     {vivritiLoanID !== '' && (
                                    <>
                                    <div className='col-md-12 mt-2'>
                                        <div className='col-md-12 form-group mb-2 float-right text-success'>
                                            <b>Application ID #{vivritiLoanID}</b>
                                        </div>

                                        <div className='col-md-12 form-group mb-2 float-right text-danger'>
                                         {Array.isArray(vivritiCallbackValidationsUPS) ? (
                                            vivritiCallbackValidationsUPS.map((option) => (
                                            <div>
                                                {option}
                                            </div> 
                                            ))
                                            ) : (
                                            <div>{vivritiCallbackValidationsUPS}</div>
                                            )}
                                            { vivritiAgreementSignedID === '' && (
                                                <div>The Agreement Signed ID has not been generated from Vivriti's side.</div>
                                            )}

                                            { vivritipostDisbursementID === '' && (
                                                <div>The Post Disbursement Id has not been generated from Vivriti's side.</div>
                                            )}
                                         </div>     
                                    </div>
                                    </>
                                    )} 
 
                                </div>    
                            </form>
                    </div>
                </div>
            </div>

            

        </div>
    </div>


</div>
</div>



                    </div>
                </div>
            </Container>

        </>
    );
}
function mapStateToProps(state) {
    return {
        leadsData: state.leadsData,
        usersData: state.usersData,
        leadInfo: state.leadInfo,
        masterProfileData: state.masterProfileData,
        leadChecklistData: state.leadChecklistData,
        interactionTypeData: state.interactionTypeData,
        getUserModuleData: state.getUserModuleData,
        incidentReporteData: state.incidentReporteData,
        leadGstByLeadData: state.leadGstByLeadData,
        leadItrByLeadData: state.leadItrByLeadData,
        leadBankStatementByLeadData: state.leadBankStatementByLeadData,
        allCloudSchemesData: state.allCloudSchemesData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(leadActions.default, userActions.default, incidentReporteActions.default, groupsUsersActions.default,masterAction.default), dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VivritiApplicationDetails);